//This is a workaround for a the implementation feature in milkey fetch.
//Milkies makes use of the window.fetch api. But it copies window.fetch on startup, and then uses the copy.
//So insted we make the window.fetch a an function that returns window.fetch. This way it doesn't matter if milkey takes an copy of window.fetch.

export const origFetch = window.fetch;
window.fetch = function (...args) {
  return window.fetch(...args);
};
